// Fuente única de la versión del bundle en ejecución.
// Parcel inlinea process.env.APP_BUILD_VERSION en build time.
// El deploy script de Forge lo exporta: export APP_BUILD_VERSION=$(git rev-parse --short HEAD)
// Fallback estable para `npm run dev`: Date.now() en cada carga purgaba la caché
// de farmacia y rompía el restore de sesión.
export const APP_BUILD_VERSION =
    (typeof process !== 'undefined' &&
        process.env &&
        process.env.APP_BUILD_VERSION) ||
    'dev'
